import { Panel } from "components/Panel/Panel";
import { shallowEqual } from "react-redux";
import { selectMatchIdsFromTournamentIds } from "selectors/Match";
import { EmptyGrowPanelText } from "styles/text";
import { TrackDriverStats } from "./TrackDriverStats";
import { TrackTeamStats } from "./TrackTeamStats";
import { TrackTopTimesStats } from "./TrackTopTimesStats";
import { useAppSelector } from "app/hooks";

interface Props {
  trackId: string;
  tournamentIds: string[];
}

export const TrackStats = ({ trackId, tournamentIds }: Props) => {
  const matchIds = useAppSelector(
    (state) => selectMatchIdsFromTournamentIds(state, tournamentIds),
    shallowEqual
  );

  if (matchIds.length === 0) {
    return (
      <Panel>
        <EmptyGrowPanelText>
          No Track Stats For The Selected Filters
        </EmptyGrowPanelText>
      </Panel>
    );
  }

  return (
    <>
      <Panel>
        <TrackTopTimesStats trackId={trackId} matchIds={matchIds} />
      </Panel>
      <Panel>
        <TrackTeamStats matchIds={matchIds} trackId={trackId} />
      </Panel>
      <Panel>
        <TrackDriverStats
          matchIds={matchIds}
          trackId={trackId}
          ratingType="Track"
        />
      </Panel>
    </>
  );
};
